<template lang="pug">
#main-layout.sidebar-layout(:class='{ "sidebar-collapsed": sidebarCollapsed }')
  // Sidebar
  modern-sidebar(@sidebar-toggle='handleSidebarToggle')

  // Wrapper Principal
  .app-wrapper
    // Navbar Superior
    navbar

    // Contenido Principal
    .main-content
      router-view

    // Footer dentro del wrapper
    footer-escality

  // Componente Global de Mensajes Unificado
  messages
</template>

<script>
import ModernSidebar from '@/layouts/navbar/ModernSidebar.vue';
import Navbar from '@/layouts/navbar/Navbar.vue';
import FooterEscality from '@/components/global/Footer.vue';
import Messages from '@/components/global/Messages.vue';

export default {
  name: 'MainLayout',
  components: {
    ModernSidebar,
    Navbar,
    FooterEscality,
    Messages,
  },
  data() {
    return {
      sidebarCollapsed: false,
    };
  },
  methods: {
    handleSidebarToggle(collapsed) {
      this.sidebarCollapsed = collapsed;
    },
  },
};
</script>

<style scoped>
#main-layout.sidebar-layout {
  display: flex;
  min-height: 100vh;
}

.app-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  /* El ancho lo define la variable que también consume ModernSidebar,
     para que no puedan volver a desincronizarse (antes 250 vs 260px
     y el sidebar tapaba el título de cada página). */
  margin-left: var(--escality-sidebar-width);
  padding-top: var(--escality-navbar-height);
  transition: margin-left 0.3s ease;
  overflow-x: hidden;
  width: calc(100% - var(--escality-sidebar-width));
}

#main-layout.sidebar-collapsed .app-wrapper {
  margin-left: var(--escality-sidebar-width-collapsed);
  width: calc(100% - var(--escality-sidebar-width-collapsed));
}

.main-content {
  flex: 1;
  padding: 1.25rem;
  background: var(--escality-content-bg);
  min-height: calc(100vh - var(--escality-navbar-height) - 60px);
}

/* Asegurar que el footer esté al final y respete el contenedor */
.app-wrapper footer.escality-footer {
  margin-top: auto;
  width: 100%;
  position: relative;
}

/* Responsive */
@media (max-width: 768px) {
  .app-wrapper {
    margin-left: 0;
    width: 100%;
  }

  #main-layout.sidebar-collapsed .app-wrapper {
    margin-left: 0;
    width: 100%;
  }
}
</style>
